import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {BotsListResult, FullBotInfo, BotSkinInfo, BotTransferRequest, BotTransferResult, BotState, BotOrder, BotStatsInfo, BotsListRequest} from "../../models/bot";
import {StatsRangeRequest} from "../../models/paymentSummary"
import JSONbig from "json-bigint";

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function botsListApi(request: BotsListRequest)
    : Promise<RequestResultValue<BotsListResult>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/bots`, JSONbig.stringify(request));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<BotsListResult>(true, body as BotsListResult);
    }
    return new RequestResultValue<BotsListResult>(false);
}

export async function deleteBotApi(id: number): Promise<RequestResult> {
    const response = await HttpService.getInstance().requestDeleteAsync(`admin/bots/${id}`);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function upsertBotApi(bot:FullBotInfo): Promise<RequestResultValue<FullBotInfo>> {
    const response=await HttpService.getInstance().requestPostAsync(`admin/bots/upsert`, JSONbig.stringify(bot));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<FullBotInfo>(true, body as FullBotInfo);
    }
    return new RequestResultValue<FullBotInfo>(false);
}

export async function getBotApi(id:number): Promise<RequestResultValue<FullBotInfo>> {
    const response=await HttpService.getInstance().requestGetAsync(`admin/bots/get?id=${id}`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<FullBotInfo>(true, body as FullBotInfo);
    }
    return new RequestResultValue<FullBotInfo>(false);
}

export async function botsListOrdersApi(botId: number)
    : Promise<RequestResultValue<BotOrder[]>> {
    const response = await HttpService.getInstance().requestGetAsync(`admin/bots/${botId}/active-orders`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<BotOrder[]>(true, body as BotOrder[]);
    }
    return new RequestResultValue<BotOrder[]>(false);
}

export async function botsListSkinsApi(botId: number, gameId: number)
    : Promise<RequestResultValue<BotSkinInfo[]>> {
    const response = await HttpService.getBotInstance().requestGetAsync(`api/bots/${botId}/inventory?gameId=${gameId}`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<BotSkinInfo[]>(true, body as BotSkinInfo[]);
    }
    return new RequestResultValue<BotSkinInfo[]>(false);
}

export async function botsSendSkinsApi(request: BotTransferRequest[])
    : Promise<RequestResultValue<BotTransferResult[]>> {
    const response = await HttpService.getBotInstance().requestPostAsync(`api/bots/transfer_inventory`, JSONbig.stringify(request));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<BotTransferResult[]>(true, body as BotTransferResult[]);
    }
    return new RequestResultValue<BotTransferResult[]>(false);
}

export async function botsListStatesApi(botIds: number[])
    : Promise<RequestResultValue<BotState[]>> {
    const response = await HttpService.getBotInstance().requestGetAsync(`api/bots?${botIds.map(e => `botIds=${e}`).join('&')}`);
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<BotState[]>(true, body as BotState[]);
    }
    return new RequestResultValue<BotState[]>(false);
}

export async function botsStartBotApi(botId: number) : Promise<RequestResult> {
    const response = await HttpService.getBotInstance().requestPostAsync(`api/bots/${botId}/start`, '{}');
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function botsStopBotApi(botId: number) : Promise<RequestResult> {
    const response = await HttpService.getBotInstance().requestPostAsync(`api/bots/${botId}/stop`, '{}');
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function botsRestartBotApi(botId: number) : Promise<RequestResult> {
    const response = await HttpService.getBotInstance().requestPostAsync(`api/bots/${botId}/restart`, '{}');
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function botsStartAllBotApi() : Promise<RequestResult> {
    const response = await HttpService.getBotInstance().requestPostAsync(`api/bots/start-all`, '{}');
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function botStatsApi(botId: number | undefined, request: StatsRangeRequest)
    : Promise<RequestResultValue<BotStatsInfo>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/bots/${botId || 0}/stats`, JSONbig.stringify(request));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSONbigNative.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<BotStatsInfo>(true, body as BotStatsInfo);
    }
    return new RequestResultValue<BotStatsInfo>(false);
}